module.exports = __webpack_public_path__ + "static/media/logo.ff8a0093.png";